(() => {
  const prompt = document.querySelector('[data-gpused-pwa-install]');
  if (!prompt || window.Shopify?.designMode) return;

  const action = prompt.querySelector('[data-gpused-pwa-action]');
  const close = prompt.querySelector('[data-gpused-pwa-close]');
  const instructions = prompt.querySelector('[data-gpused-pwa-instructions]');
  if (!action || !close || !instructions) return;

  const firstSeenKey = 'gpused-pwa-first-seen';
  const dismissedKey = 'gpused-pwa-dismissed';
  const installedKey = 'gpused-pwa-installed';
  const androidDelay = 90 * 1000;
  const iosDelay = 600 * 1000;
  const dismissFor = 30 * 24 * 60 * 60 * 1000;
  const userAgent = window.navigator.userAgent || '';
  const isIos = /iPad|iPhone|iPod/.test(userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  const isMobile = isIos || /Android/i.test(userAgent);
  const delay = isIos ? iosDelay : androidDelay;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  const readStorage = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };
  const writeStorage = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (_error) {
      // The install prompt can still work when storage is unavailable.
    }
  };

  if (!isMobile || isStandalone || readStorage(installedKey) === '1') return;

  const now = Date.now();
  const dismissedAt = Number(readStorage(dismissedKey) || 0);
  if (dismissedAt && now - dismissedAt < dismissFor) return;

  let firstSeenAt = Number(readStorage(firstSeenKey) || 0);
  if (!firstSeenAt || firstSeenAt > now) {
    firstSeenAt = now;
    writeStorage(firstSeenKey, String(firstSeenAt));
  }

  let installEvent = null;
  let timer = null;
  let instructionsShown = false;

  const canShow = () => isIos || Boolean(installEvent);
  const show = () => {
    if (!canShow()) return;
    prompt.hidden = false;
  };

  const schedule = () => {
    window.clearTimeout(timer);
    const remaining = delay - (Date.now() - firstSeenAt);
    timer = window.setTimeout(show, Math.max(0, remaining));
  };

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installEvent = event;
    action.textContent = 'Install';
    schedule();
  });

  window.addEventListener('appinstalled', () => {
    writeStorage(installedKey, '1');
    prompt.hidden = true;
    installEvent = null;
  });

  close.addEventListener('click', () => {
    writeStorage(dismissedKey, String(Date.now()));
    prompt.hidden = true;
  });

  action.addEventListener('click', async () => {
    if (installEvent) {
      installEvent.prompt();
      await installEvent.userChoice;
      installEvent = null;
      prompt.hidden = true;
      return;
    }

    if (instructionsShown) {
      writeStorage(dismissedKey, String(Date.now()));
      prompt.hidden = true;
      return;
    }

    instructionsShown = true;
    instructions.hidden = false;
    action.textContent = 'Got it';
  });

  if (isIos) {
    action.textContent = 'Show me';
    schedule();
  }
})();
